module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-06-89d35589cf805ec22f1b7e7764b9859e.svg";